import { useQuery } from '@tanstack/react-query'

import apiClient from '@/api/axios'
import { API_ENDPOINTS } from '@/api/endpoints'

import { logger } from '@/lib/logger'

export type Translations = {
  [locale: string]: {
    name?: string
    description?: string
  }
}

export type Plan = {
  id: string
  branch_id?: string | null
  name: string
  description?: string
  price: number
  currency: string // e.g., "USD", "KWD"
  duration_value?: number | null
  duration_unit?: 'day' | 'week' | 'month' | 'year' | null
  plan_type: 'trial' | 'standard' | 'lifetime'
  is_active: boolean
  is_global: boolean
  is_public: boolean
  is_trial: boolean
  created_at: string
  updated_at: string
  has_trial: boolean
  trial_days: number | null
  trial_class_limit: number | null
  class_limit: number | null
  translations?: Translations
}

async function fetchPlans(branchId?: string | null): Promise<Plan[]> {
  const response = await apiClient.get(API_ENDPOINTS.register.plans, {
    params: branchId ? { branch_id: branchId } : {},
  })
  logger.debug('fetchPlans response', response.data)
  return response?.data?.data?.data
}

export function usePlans(branchId: string | null) {
  return useQuery({
    queryKey: ['plans', branchId],
    queryFn: () => fetchPlans(branchId!),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    enabled: !!branchId,
  })
}

async function fetchAdminPlans(branchId?: string | null): Promise<Plan[]> {
  const response = await apiClient.get(API_ENDPOINTS.plans.active, {
    params: branchId ? { branch_id: branchId } : {},
  })
  logger.debug('fetchPlans response', response.data)
  return response?.data?.data?.data
}

export function useAdminPlans(branchId: string | null) {
  return useQuery({
    queryKey: ['admin-plans', branchId],
    queryFn: () => fetchAdminPlans(branchId!),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    enabled: !!branchId,
  })
}
